import { CALL_API, Schemas } from '../../common/middleware/api';

export const TEACHERS_REQUEST = 'TEACHERS_REQUEST';
export const TEACHERS_SUCCESS = 'TEACHERS_SUCCESS';
export const TEACHERS_FAILURE = 'TEACHERS_FAILURE';

export const TEACHERS_UNPAGED_REQUEST = 'TEACHERS_UNPAGED_REQUEST';
export const TEACHERS_UNPAGED_SUCCESS = 'TEACHERS_UNPAGED_SUCCESS';
export const TEACHERS_UNPAGED_FAILURE = 'TEACHERS_UNPAGED_FAILURE';

export const NOTEACHERS_REQUEST = 'NOTEACHERS_REQUEST';
export const NOTEACHERS_SUCCESS = 'NOTEACHERS_SUCCESS';
export const NOTEACHERS_FAILURE = 'NOTEACHERS_FAILURE';

export const TEACHER_FETCH_REQUEST = 'TEACHER_GET_REQUEST';
export const TEACHER_FETCH_SUCCESS = 'TEACHER_GET_SUCCESS';
export const TEACHER_FETCH_FAILURE = 'TEACHER_GET_FAILURE';

export const TEACHER_CREATE_REQUEST = 'TEACHER_CREATE_REQUEST';
export const TEACHER_CREATE_SUCCESS = 'TEACHER_CREATE_SUCCESS';
export const TEACHER_CREATE_FAILURE = 'TEACHER_CREATE_FAILURE';

export const TEACHER_UPDATE_REQUEST = 'TEACHER_UPDATE_REQUEST';
export const TEACHER_UPDATE_SUCCESS = 'TEACHER_UPDATE_SUCCESS';
export const TEACHER_UPDATE_FAILURE = 'TEACHER_UPDATE_FAILURE';

export const loadTeachers = ({ franchiseeId, ...options }) => ({
	[CALL_API]: {
		types: [TEACHERS_REQUEST, TEACHERS_SUCCESS, TEACHERS_FAILURE],
		endpoint: 'api/teachers',
		request: { franchiseeId, ...options },
		schema: Schemas.TEACHER_ARRAY
	},
	franchiseeId
});

export const loadUnpagedTeachers = ({ franchiseeId, ...options }) => ({
	[CALL_API]: {
		types: [TEACHERS_UNPAGED_REQUEST, TEACHERS_UNPAGED_SUCCESS, TEACHERS_UNPAGED_FAILURE],
		endpoint: 'api/teachers/unpaged',
		request: { franchiseeId, ...options },
		schema: Schemas.TEACHER_ARRAY
	},
	franchiseeId
});

export const loadNoTeacherUsers = (franchiseeId) => ({
	[CALL_API]: {
		types: [NOTEACHERS_REQUEST, NOTEACHERS_SUCCESS, NOTEACHERS_FAILURE],
		endpoint: 'api/teachers/noTeacherUsers',
		request: { franchiseeId },
		schema: Schemas.NOTEACHER_ARRAY
	},
	franchiseeId
});

export const fetchTeacher = (id, onSuccessEvent) => ({
	[CALL_API]: {
		types: [TEACHER_FETCH_REQUEST, TEACHER_FETCH_SUCCESS, TEACHER_FETCH_FAILURE],
		endpoint: `api/teachers/${id}`,
		schema: Schemas.TEACHER,
		onSuccessEvent
	}
});

export const createTeacher = (teacher, franchiseeId, history) => ({
	[CALL_API]: {
		types: [TEACHER_CREATE_REQUEST, TEACHER_CREATE_SUCCESS, TEACHER_CREATE_FAILURE],
		endpoint: 'api/teachers',
		method: 'POST',
		request: teacher,
		schema: Schemas.TEACHER,
		form: 'teacher',
		transition: {
			history,
			successPath: (response) => {
				const { id } = response.entities.teachers[response.result];
				return `/franchisees/${franchiseeId}/teachers/${id}`;
			}
		}
	}
});

export const updateTeacher = (id, teacher) => ({
	[CALL_API]: {
		types: [TEACHER_UPDATE_REQUEST, TEACHER_UPDATE_SUCCESS, TEACHER_UPDATE_FAILURE],
		endpoint: `api/teachers/${id}`,
		method: 'PUT',
		request: teacher,
		schema: Schemas.TEACHER,
		form: 'teacher'
	}
});

export const createTeacherFromExistingUser = (id, franchiseeId, history, onSuccessEvent) => ({
	[CALL_API]: {
		types: [TEACHER_CREATE_REQUEST, TEACHER_CREATE_SUCCESS, TEACHER_CREATE_FAILURE],
		endpoint: `api/teachers/fromExisting/${id}`,
		method: 'POST',
		schema: Schemas.TEACHER,
		form: 'teacher',
		onSuccessEvent,
		transition: {
			history,
			successPath: (response) => {
				const { id } = response.entities.teachers[response.result];
				return `/franchisees/${franchiseeId}/teachers/${id}`;
			}
		}
	}
});